export enum LLMModelPurpose {
    KBo = "KBo",
    ModelBuilder = "ModelBuilder",
}

export interface LLMManagementModelViewModel {
    id: string;
    name: string;
    underlyingModelName: string;
    isThinkingModel: boolean;
    thinkingEffortLevels: string[] | null;
    purpose: LLMModelPurpose;
    isActive: boolean;
}

export interface InlineDeploymentPayload {
    hostId: string;
    priority: number;
    configuration: Record<string, unknown>;
}

export interface DeploymentConfigTestPayload {
    modelId?: string;
    underlyingModelName?: string;
    hostId: string;
    priority: number;
    isThinkingModel?: boolean;
    thinkingEffortLevels?: string[] | null;
    configuration: Record<string, unknown>;
}

export interface CreateLLMModelPayload {
    name: string;
    underlyingModelName: string;
    isThinkingModel: boolean;
    thinkingEffortLevels: string[] | null;
    purpose: LLMModelPurpose;
    initialDeployment: InlineDeploymentPayload;
}

export interface CreateEmbeddingModelPayload {
    name: string;
    initialDeployment: InlineDeploymentPayload;
}
